import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";
import { RadioList } from "./RadioList";
import { Repeater, RepeaterItem } from "./Repeater";

export class F15_2014 extends BaseForm {
    override updateForm() {

        //this.JOINT_PROCUREMENT_INVOLVED_change();
        //this.ADDRESS_FURTHER_INFO_change();
        //this.URL_TOOL_use_change();
        //this.economic_criteria_change;
        //this.DOCUMENT_change();
    }
}

//    JOINT_PROCUREMENT_INVOLVED_change() {
//        this.muVisible((this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked, "PROCUREMENT_LAW_block");
//    }

//    ADDRESS_FURTHER_INFO_change() {
//        const v = this.muNamedWidget.ADDRESS_FURTHER_INFO.muFetchData() as string;
//        this.muVisible(v == "ADDRESS", "ADDRESS_FURTHER_INFO_ADDRESS");
//    }

//    URL_TOOL_use_change() {
//        this.muVisible((this.ui.URL_TOOL_use as HTMLInputElement).checked, "URL_TOOL");
//    }

//    economic_criteria_change() {
//        this.muVisible((this.ui.economic_criteria as HTMLInputElement).checked, "financial_info_criteria");
//        this.muVisible((this.ui.economic_criteria as HTMLInputElement).checked, "financial_min_level_standarts");
//    }

//    DOCUMENT_change() {
//        const v = this.muNamedWidget.DOCUMENT.muFetchData() as string;
//        //this.muVisible(v == "RESTRICTED", "url_restriction");
//        //this.muVisible(v == "FULL", "url_restriction");
//        this.muVisible(!!v, "url_restriction")
//    }
//}

//    export class F02_2014_PARTICIPATION extends BaseWidget {
//    updateForm() {
//        this.type_change();
//        this.URL_change();
//    }

//    URL_change() {
//        this.muVisible((this.ui.URL as HTMLInputElement).checked, "URL_block");
//    }

//    type_change() {
//        const v = this.muNamedWidget.type.muFetchData() as string;
//        this.muVisible(v == "ADDRESS", "ADDRESS");
//        //this.muVisible(v == "URL", "URL_block");
//    }
export class F15_2014_OBJECT_CONTRACT extends BaseWidget {
    repeater: Repeater;

    LOT_DIVISION_change() {
        this.repeater = this.muNamedWidget.OBJECT_DESCR as Repeater;
        this.repeater.maxCount = (this.muNamedWidget.LOT_DIVISION as RadioList).muFetchData() === "LOT_DIVISION" ? 1000 : 1;
    }
}

export class F15_2014_PROCEDURE extends BaseWidget {
    private noticeNumberErrMsg: HTMLElement|null = null;

    NOTICE_NUMBER_OJ_change(sender) {
        const el: HTMLElement = sender.target;

        if (this.noticeNumberErrMsg === null) {
            this.noticeNumberErrMsg = this.createErrorMsg(el, 'NOTICE_NUMBER_OJ', 'Nesprávný formát');
        }

        typeof this.checkFormat(sender.target, "NoticeNumber") === "string" ? this.noticeNumberErrMsg.classList.remove('hide-this') : this.noticeNumberErrMsg.classList.add('hide-this');
    }
}

export class F15_2014_AWARD_OF_CONTRACT extends RepeaterItem {
    repeater: Repeater;

    AWARDED_TO_GROUP_change() {
        this.repeater = this.muNamedWidget.ADDRESS_CONTRACTOR as Repeater;
        this.repeater.maxCount = (this.muNamedWidget.AWARDED_TO_GROUP as RadioList).muFetchData() === "AWARDED_TO_GROUP" ? 100 : 1;
    }
}

export class DateWidget extends BaseWidget {
    override afterIndex() {
        this.ui.DATE_DISPATCH_NOTICE.innerText = new Date().toLocaleDateString("cs-CZ", { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
}
   
export class F15_2014_CURRENCY extends BaseWidget {
}

export class F15_2014_CURRENCY2 extends BaseWidget {
    override muBindData(src) {
        super.muBindData({VALUE: src});
    }

    override muFetchData() {
        return super.muFetchData().VALUE;
    }
}

export class F15_2014_CURRENCY3 extends BaseWidget {
}
